import { render, staticRenderFns, recyclableRender, components } from "./practice-page.vue?vue&type=template&id=d72d03a8&scoped=true&"
var renderjs
import script from "./practice-page.vue?vue&type=script&lang=js&"
export * from "./practice-page.vue?vue&type=script&lang=js&"
import style0 from "./practice-page.vue?vue&type=style&index=0&id=d72d03a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72d03a8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/practice-page.vue"
export default component.exports